module.exports = __webpack_public_path__ + "static/media/pic-st1.7a4d8696.jpg";